<div class="footer__container">
    <div class="footer__promo-detail">
        @if(data()?.price !== 0) {
          <div class="total">
              <div class="label">{{'packageDetail.totalPrice' | translate}}</div>
              <div class="price">Rp{{data()?.price ?? 0 | numberSeparator}}</div>
          </div>

        }
        <button class="buy__btn" [ngClass]="{'buy__btn-disabled' : data()?.stock === 0 && data()?.isAffiliatePackage}"
            [disabled]="data()?.stock === 0 && data()?.isAffiliatePackage" (click)="onClickBuy()">{{(data()?.btnLabel || 'packageDetail.buy')| translate}}</button>
    </div>
</div>
